import { jsx } from 'react/jsx-runtime';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { useDeleteOrLeaveResource } from '../../hooks/useDeleteOrLeaveResource.js';
import { IconTrash } from '@fabric-app/icons/svg';

const DropdownItemResourceDeleteOrLeave = ({ onConfirmDelete, onConfirmLeave }) => {
  const { label, action, disabledReason } = useDeleteOrLeaveResource({
    onConfirmDelete,
    onConfirmLeave
  });
  return /* @__PURE__ */ jsx(DropdownMenu.Item, {
    iconElement: /* @__PURE__ */ jsx(IconTrash, {}),
    variant: "danger",
    onClick: action,
    disabledReason,
    children: label
  });
};

export { DropdownItemResourceDeleteOrLeave };
//# sourceMappingURL=DropdownItemResourceDeleteOrLeave.js.map
